module.exports = __webpack_public_path__ + "62b5272b168e4afcb043f24457400fd6.MP3";